import { loadStripe } from '@stripe/stripe-js/pure';

window.giftyPaymentBus = {};
window.giftyPaymentBus.stripe = null;
window.giftyPaymentBus.card = null;
window.giftyPaymentBus.iDEALBank = null;
window.giftyPaymentBus.sofortCountry = null;
window.giftyPaymentBus.initialize = async () => {
    window.giftyPaymentBus.stripe = await loadStripe(process.env.STRIPE_CLIENT_KEY, {
        locale: window.parent.Gifty.language,
    });
    const elements = window.giftyPaymentBus.stripe.elements();
    const style = {
        base: {
            color: '#6A7272',
            padding: '14px',
        },
    };

    window.giftyPaymentBus.card = elements.create('card', { hidePostalCode: true, style });
};
